import { FC } from "react";

const FilterItem: FC<{
  title: string;
  isActive: boolean;
  handleFilter: () => void;
}> = ({ title, handleFilter, isActive }) => {
  return (
    <div style={{ display: "flex", gap: "0.5em", marginTop: "0.5em" }}>
      <div
        onClick={() => handleFilter()}
        style={{
          width: "15px",
          height: "15px",
          border: "1px solid white",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isActive && (
          <div
            style={{
              width: "60%",
              height: "60%",
              borderRadius: "1px",
              background: "#2bfda7",
            }}
          />
        )}
      </div>
      <p style={{ fontSize: "0.8em", fontWeight: "600", color: "white" }}>
        {title}
      </p>
    </div>
  );
};

export default FilterItem;
